import { cn } from "@/lib/utils";

export interface MatrixCell {
  id: string;
  label: string;
  on: boolean;
  level?: "low" | "mid" | "high";
  valueLabel?: string;
}

export function MatrixHeat({
  cells,
  className,
}: {
  cells: MatrixCell[];
  className?: string;
}) {
  return (
    <div className={cn("cap-matrix", className)}>
      {cells.map((c) => (
        <div
          key={c.id}
          className={cn(
            "cap-matrix-cell",
            c.on && "on",
            c.on && c.level === "high" && "high",
          )}
        >
          <span className="cap-matrix-label">{c.label}</span>
          <span className="cap-matrix-val">
            {c.valueLabel ?? (c.on ? "Yes" : "—")}
          </span>
        </div>
      ))}
    </div>
  );
}
